// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DreamRow__row___jpg8t {
    display: block;
    -webkit-text-size-adjust: none;
    text-size-adjust: none;
    padding: 5px 3px 5px 8px;
    border-radius: 5px;
    width: min(100%, 760px);
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    background: linear-gradient(
        90deg,
        hsl(220deg 10% 12% / 0.42) 0%,
        hsl(220deg 10% 16% / 0.58) 18%,
        hsl(220deg 12% 10% / 0.58) 50%,
        hsl(220deg 10% 16% / 0.58) 82%,
        hsl(220deg 10% 12% / 0.42) 100%
    );
    box-shadow:
        inset 0 1px 0 hsl(210deg 30% 80% / 0.05),
        inset 0 -1px 0 hsl(220deg 30% 3% / 0.16);
}

.DreamRow__row___jpg8t:where(:nth-child(even)) {
    background: linear-gradient(
        90deg,
        hsl(198deg 32% 13% / 0.42) 0%,
        hsl(198deg 30% 16% / 0.62) 18%,
        hsl(204deg 26% 11% / 0.62) 50%,
        hsl(198deg 30% 16% / 0.62) 82%,
        hsl(198deg 32% 13% / 0.42) 100%
    );
    box-shadow:
        inset 0 1px 0 hsl(190deg 55% 65% / 0.06),
        inset 0 -1px 0 hsl(220deg 30% 3% / 0.18);
}

.DreamRow__rowExpanded___I7vl_ {
    overflow: visible;
    white-space: normal;
    background:
        linear-gradient(
            90deg,
            hsl(220deg 12% 18% / 0.08) 0%,
            hsl(220deg 12% 18% / 0.5) 30%,
            hsl(220deg 10% 10% / 0.36) 50%,
            hsl(220deg 12% 18% / 0.5) 70%,
            hsl(220deg 12% 18% / 0.08) 100%
        );
    box-shadow:
        inset 0 1px 0 hsl(0deg 0% 100% / 0.04),
        inset 0 -1px 0 hsl(220deg 20% 4% / 0.16);
}

.DreamRow__row___jpg8t:hover {
    background: linear-gradient(
        90deg,
        hsl(198deg 28% 20% / 0) 0%,
        hsl(198deg 28% 20% / 0.42) 30%,
        hsl(220deg 12% 11% / 0.28) 50%,
        hsl(198deg 28% 20% / 0.42) 70%,
        hsl(198deg 28% 20% / 0) 100%
    );
}

.DreamRow__hasTooManyChildren___vBvg2 {
    color: #ff8c8c;
    opacity: 1 !important;
    font-weight: bold;
}

.DreamRow__highDifficulty___q2AOG {
   opacity: 0.8; 
}

.DreamRow__waypoint___RTfcH {
    color: yellowgreen
}

.DreamRow__randomDream___jrNCm {
    font-weight: bold;
    padding: 3px 5px;
    border-radius: 6px;
    background: linear-gradient(
        90deg,
        hsl(44deg 52% 22% / 0) 0%,
        hsl(44deg 52% 22% / 0.18) 30%,
        hsl(38deg 40% 14% / 0.1) 50%,
        hsl(44deg 52% 22% / 0.18) 70%,
        hsl(44deg 52% 22% / 0) 100%
    );
}

.DreamRow__problem___Aq1_Q {
    color: #ffb89e;
}

/* .fascination {
    text-shadow: 0px 0px 10px gold;
} */

.DreamRow__strikethrough___gSVWm {
    text-decoration: line-through;
}

.DreamRow__dropTargetsContainer___OCaiA {
    display: flex;
    flex-flow: row;
    flex-wrap: nowrap;
    align-items: center;
    gap: 3px;
    margin-left: 6px;
    padding: 3px;
    background: hsl(220deg 14% 8% / 0.5);
    border: 1px solid hsl(47deg 55% 58% / 0.14);
    border-radius: 7px;
    white-space: nowrap;
}

.DreamRow__dropTargetsContainer___OCaiA:empty {
    display: none;
}

.DreamRow__dropTarget___M0hfJ {
    --drop-target-color: hsl(47deg 35% 82% / 0.72);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 1 1 0;
    min-height: 24px;
    padding: 0 6px;
    border: 1px solid transparent;
    border-radius: 4px;
    color: var(--drop-target-color);
    font-size: 11px;
    line-height: 1;
    opacity: 0.82;
    transition: background 120ms ease, border-color 120ms ease, color 120ms ease,
        opacity 120ms ease;
}

.DreamRow__dropTarget___M0hfJ[data-is-over="true"] {
    border-color: var(--drop-target-color);
    background: var(--drop-target-color);
    color: hsl(220deg 18% 9%);
    font-weight: bold;
    opacity: 1;
}

.DreamRow__dropTargetToday___JAC3V { --drop-target-color: hsl(83deg 58% 62%); }
.DreamRow__dropTargetComplete___Q_tO0 { --drop-target-color: hsl(148deg 52% 63%); }
.DreamRow__dropTargetDelete___viyvi { --drop-target-color: hsl(8deg 70% 68%); }

.DreamRow__rowExpanded___I7vl_ .DreamRow__dropTargetsContainer___OCaiA {
    flex-wrap: wrap;
    gap: 3px 6px;
    margin: 2px 0 0;
    padding: 3px;
    white-space: normal;
}

.DreamRow__expandedDropTargetsSlot___ZWX7j {
    grid-column: 2 / 3;
    min-width: 0;
}

.DreamRow__nameExpansionButton___qGX6l {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    align-self: stretch;
    width: 24px;
    min-height: 22px;
    box-sizing: border-box;
    margin-left: auto;
    padding: 0;
    border: 1px solid hsl(47deg 70% 62% / 0.22);
    border-radius: 6px;
    background: hsl(220deg 14% 10% / 0.34);
    color: hsl(47deg 60% 78% / 0.9);
    font-size: 9px;
    line-height: 1;
}

.DreamRow__expandedDreamControls___uuSNk {
    display: inline-flex;
    align-self: center;
    padding-top: 1px;
}

.DreamRow__nameExpansionButton___qGX6l:active {
    transform: scale(0.94);
    color: white;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `DreamRow__row___jpg8t`,
	"rowExpanded": `DreamRow__rowExpanded___I7vl_`,
	"hasTooManyChildren": `DreamRow__hasTooManyChildren___vBvg2`,
	"highDifficulty": `DreamRow__highDifficulty___q2AOG`,
	"waypoint": `DreamRow__waypoint___RTfcH`,
	"randomDream": `DreamRow__randomDream___jrNCm`,
	"problem": `DreamRow__problem___Aq1_Q`,
	"strikethrough": `DreamRow__strikethrough___gSVWm`,
	"dropTargetsContainer": `DreamRow__dropTargetsContainer___OCaiA`,
	"dropTarget": `DreamRow__dropTarget___M0hfJ`,
	"dropTargetToday": `DreamRow__dropTargetToday___JAC3V`,
	"dropTargetComplete": `DreamRow__dropTargetComplete___Q_tO0`,
	"dropTargetDelete": `DreamRow__dropTargetDelete___viyvi`,
	"expandedDropTargetsSlot": `DreamRow__expandedDropTargetsSlot___ZWX7j`,
	"nameExpansionButton": `DreamRow__nameExpansionButton___qGX6l`,
	"expandedDreamControls": `DreamRow__expandedDreamControls___uuSNk`
};
module.exports = ___CSS_LOADER_EXPORT___;
